export const FormInlineEditingOptinName = 'CMv2:FormsInlineEditing';
export const OPTED_IN = 'OPTED_IN';
export const OPTED_OUT = 'OPTED_OUT';